module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('em', [_vm._v("Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#fig1"
    }
  }, [_vm._v("Fig. 1 The Banishing Pentagram of Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#fig2"
    }
  }, [_vm._v("Fig. 2 The Invoking Pentagram of Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#fig3"
    }
  }, [_vm._v("Fig. 3 The Cabalistic Tree of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm#fig4"
    }
  }, [_vm._v("Fig. 4 A typical Talisman")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ap2.htm#fig5"
    }
  }, [_vm._v("Fig. 5 The sigil of the name Regardie on the Square of the Sun")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e594da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/list.vue
// module id = 63
// module chunks = 0